import { iosCartBoldWeight } from 'features/cart/styles';
import { StyleProp, StyleSheet, TextStyle } from 'react-native';
import { Typography } from 'ucl';

import { A11yWrapper } from 'components/ui/a11y-wrapper';
import { AccessibleMainContent } from 'state/ui';
import { primitive } from 'styles/constants';

export const CartSectionHeader = ({
  title,
  testID,
  style,
}: {
  title: string;
  testID?: string;
  style?: StyleProp<TextStyle>;
}) => {
  return (
    <A11yWrapper>
      <AccessibleMainContent>
        <Typography style={[styles.defaultText, style]} testID={testID}>
          {title}
        </Typography>
      </AccessibleMainContent>
    </A11yWrapper>
  );
};

const styles = StyleSheet.create({
  defaultText: {
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 20,
    ...iosCartBoldWeight,
    color: primitive.$bbqBrown,
  },
});
